import { render, staticRenderFns } from "./ClubPlayerClientStatsPanel.vue?vue&type=template&id=7982d788&scoped=true"
import script from "./ClubPlayerClientStatsPanel.vue?vue&type=script&lang=js"
export * from "./ClubPlayerClientStatsPanel.vue?vue&type=script&lang=js"
import style0 from "./ClubPlayerClientStatsPanel.vue?vue&type=style&index=0&id=7982d788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7982d788",
  null
  
)

export default component.exports